import { App } from "../../App";
import { InscriptionDocumentOrigin } from "../../enum/InscriptionDocumentOrigin";
import * as  moment from "../../../node_modules/moment/moment";

let app = new App();

export class InscriptionDocument{
    private _origin: number;
    private _order: number;
    private _urlToDownload: string;
    private _registryErrorDate: moment.Moment;
    private _registryReference: string;
    private _fileName: string;
    private _date: string | null;
    private _time: string | null;

    constructor(doc: any){
        this._origin = doc.origin;
        this._order = InscriptionDocumentOrigin.order[doc.origin];
        this._urlToDownload = app.requestTo + doc.url + "?origin=" + app.origin;
        this._registryErrorDate = doc.registryErrorDate;
        this._registryReference = doc.registryReference;
        this._fileName = doc.fileName ? doc.fileName : undefined;
        this._date = doc.registryDate ? moment.utc(doc.registryDate).local().format('L') : null;
        this._time = doc.registryDate ? moment.utc(doc.registryDate).local().format('HH:mm') : null;
    }

    public set origin(origin: number){
        this._origin = origin;
    }

    public get origin(){
        return this._origin;
    }

    public set order(order: number){
        this._order = order;
    }

    public get order(){
        return this._order;
    }

    public set urlToDownload(urlToDownload: string){
        this._urlToDownload = urlToDownload;
    }

    public get urlToDownload(){
        return this._urlToDownload;
    }

    public set registryErrorDate(registryErrorDate: moment.Moment){
        this._registryErrorDate = registryErrorDate;
    }

    public get registryErrorDate(){
        return this._registryErrorDate;
    }

    public set registryReference(registryReference: string){
        this._registryReference = registryReference;
    }

    public get registryReference(){
        return this._registryReference;
    }

    public set fileName(fileName: string){
        this._fileName = fileName;
    }

    public get fileName(){
        return this._fileName;
    }
        
    public get date() {
        return this._date;
    }
    
    public get time() {
        return this._time;
    }
}
